var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['dh-psy-journal', {
  'dh-psy-journal--left': _vm.align === 'left',
  'dh-psy-journal--right': _vm.align === 'right',
  'dh-psy-journal--inverse': _vm.inverse
}]},[_c('div',{staticClass:"dh-psy-journal__wrapper"},[(_vm.title)?_c('h4',[_vm._v(_vm._s(this.title))]):_vm._e(),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.content))])]),_vm._v(" "),(_vm.author)?_c('p',{staticClass:"dh-psy-journal__author",domProps:{"innerHTML":_vm._s(_vm.author)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }